export default __webpack_public_path__ + "static/space-5-43b7333da5bd8a940b52d05d71dbdd3e.jpg";